// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"700ac19d","304":"31d6cfe0","469":"fa7c7fa6","544":"fa7c7fa6"}[chunkId] + ".chunk.css";
};